import { jsx as _jsx } from "react/jsx-runtime";
import { UserIcon } from '@heroicons/react/24/solid';
import Tabs from '@web/components/layout/Tabs';
import { YourProfileTab } from '@web/components/Profile/Tabs/YourProfile';
import { profileActiveTabs } from '@web/utility/tabs';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
export var Profile = function () {
    var t = useTranslation().t;
    var _a = useParams().activeTab, activeTab = _a === void 0 ? 'profile' : _a;
    var tabs = [
        {
            id: profileActiveTabs.profile,
            name: t('profile.profile'),
            icon: _jsx(UserIcon, {}),
            Component: YourProfileTab
        }
    ];
    return (_jsx("div", { children: _jsx(Tabs, { active: activeTab, tabs: tabs }) }));
};
